import { render, staticRenderFns } from "./chartsForm.vue?vue&type=template&id=3fe482cd&scoped=true"
import script from "./chartsForm.vue?vue&type=script&lang=js"
export * from "./chartsForm.vue?vue&type=script&lang=js"
import style0 from "./chartsForm.vue?vue&type=style&index=0&id=3fe482cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe482cd",
  null
  
)

export default component.exports